var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideoRecorder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6413 7.44289C18.6413 6.93804 18.6413 6.68562 18.5414 6.56873C18.4548 6.46731 18.3249 6.41349 18.1919 6.42395C18.0387 6.43602 17.8602 6.61451 17.5032 6.97149L14.4746 10.0001L17.5032 13.0287C17.8602 13.3857 18.0387 13.5641 18.1919 13.5762C18.3249 13.5867 18.4548 13.5328 18.5414 13.4314C18.6413 13.3145 18.6413 13.0621 18.6413 12.5573V7.44289Z",
    stroke: "#344054",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.97461 8.16675C1.97461 6.76662 1.97461 6.06655 2.24709 5.53177C2.48678 5.06137 2.86923 4.67892 3.33963 4.43923C3.87441 4.16675 4.57448 4.16675 5.97461 4.16675H10.4746C11.8747 4.16675 12.5748 4.16675 13.1096 4.43923C13.58 4.67892 13.9624 5.06137 14.2021 5.53177C14.4746 6.06655 14.4746 6.76662 14.4746 8.16675V11.8334C14.4746 13.2335 14.4746 13.9336 14.2021 14.4684C13.9624 14.9388 13.58 15.3212 13.1096 15.5609C12.5748 15.8334 11.8747 15.8334 10.4746 15.8334H5.97461C4.57448 15.8334 3.87441 15.8334 3.33963 15.5609C2.86923 15.3212 2.48678 14.9388 2.24709 14.4684C1.97461 13.9336 1.97461 13.2335 1.97461 11.8334V8.16675Z",
    stroke: "#344054",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoRecorder);
export default __webpack_public_path__ + "static/media/video-recorder.e8a26037762a0ab48aefb6a5cfdd275b.svg";
export { ForwardRef as ReactComponent };